var _circle, _line, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackToTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    stroke: "white",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 5,
    x2: 18,
    y2: 5,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9414 12.4819L12.9427 12.4806C13.0753 12.3475 13.15 12.1679 13.15 11.9804C13.15 11.7929 13.0753 11.6133 12.9427 11.4801L12.9427 11.4801L12.9416 11.4791L10.4818 9.05783C10.4816 9.0577 10.4815 9.05757 10.4814 9.05744C10.4154 8.99165 10.3369 8.93952 10.2505 8.90395C10.164 8.86832 10.0713 8.85 9.97762 8.85C9.88399 8.85 9.79123 8.86832 9.70472 8.90395C9.61837 8.93952 9.53989 8.99165 9.47385 9.05744C9.47372 9.05757 9.47359 9.0577 9.47347 9.05783L7.01362 11.4791L7.00681 11.4858L7.0009 11.4933C6.89456 11.6286 6.84122 11.7976 6.85118 11.9691C6.86114 12.1406 6.93369 12.3024 7.05487 12.4247C7.176 12.547 7.33753 12.6216 7.5095 12.6354C7.68146 12.6491 7.85289 12.6011 7.99219 12.4998L8.00128 12.4932L8.00928 12.4853L9.25662 11.2557V18.4445C9.25662 18.6323 9.33232 18.812 9.46635 18.9441C9.60032 19.0762 9.78157 19.15 9.97011 19.15C10.1587 19.15 10.3399 19.0762 10.4739 18.9441C10.6079 18.812 10.6836 18.6323 10.6836 18.4445V11.252L11.9309 12.4816L11.9312 12.4819C12.0658 12.6138 12.2474 12.6876 12.4363 12.6876C12.6252 12.6876 12.8069 12.6138 12.9414 12.4819Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackToTop);
export default __webpack_public_path__ + "static/media/back-to-top.6de93118e2bcc6881b64d760e10a021f.svg";
export { ForwardRef as ReactComponent };